<template>
    <section class="appointment-calendar availability-calendar">
        <header class="appointment-calendar__weekdays">
            <h5 v-for="(weekday, index) in weekDays" :key="index" class="appointment-calendar__weekday">
                {{ weekday }}
            </h5>
        </header>

        <ol class="appointment-calendar__days">
            <li
                v-for="(day, index) in monthDaysWithoutEndPadding"
                :key="index"
                :class="calendarDayClass(day)"
                @click="day && selectDay(day)"
            >
                <div class="availability-calendar-day-small-center">
                    {{ day ? day.day : '' }}
                </div>
            </li>
        </ol>
    </section>
</template>

<script>
    import dayjs from 'dayjs'
    import CalendarMixin from 'mixins/CalendarMixin'

    export default {
        mixins: [CalendarMixin],

        props: {
            selectedDate: {
                type: [Object, String, Date],
                default: null,
            },
        },

        methods: {
            calendarDayClass(day) {
                return {
                    'appointment-calendar__day': true,
                    'availability-calendar-day-small': true,
                    'availability-calendar-day-small-center--selected': this.isSelected(day),
                    'availability-calendar-day-small--interactive': !!day,
                }
            },

            isSelected(day) {
                if (!day || !day.date) return false
                if (this.selectedDate) {
                    return dayjs(this.selectedDate).isSame(day.date, 'day')
                }
                const today = dayjs().startOf('day')
                return day.date.isSame(today, 'day')
            },

            selectDay(day) {
                if (!day || !day.date) return
                this.$emit('select-date', day.date)
            },
        },
    }
</script>

<style scoped>
    .availability-calendar-day-small--interactive {
        cursor: pointer;
    }

    .availability-calendar-day-small--interactive:not(.availability-calendar-day-small-center--selected):hover {
        background-color: #f1f5f9;
    }

    .availability-calendar-day-small-center {
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
        font-size: 13px;
    }
</style>
